import { createSelector } from 'reselect';
export const isMapExist = createSelector([(state) => state.config.components, (state) => state.page.pageTemplates], (components, templates) => {
    const keyMap = Object.entries(components)
        .filter(([, component]) => component.type === 'Map')
        .map(([key]) => key);
    return !!keyMap && templates.some((template) => template.areas.indexOf(keyMap) !== -1);
});
//# sourceMappingURL=selectors.js.map